import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ExportClef} from "@domain/admin/parametre/api/clefs/ExportClef";
import {Result} from "@domain/common/http/result";
import {environment} from "@environments/environment";
import {HttpClient} from "@angular/common/http";
import {first} from "rxjs/operators";

/**
 * Service de gestion des clefs API
 *
 * @author Lionel Gimenez
 */
@Injectable()
export class ApiClefsService {

    /**
     * Constructeur
     */
    constructor(
        private http: HttpClient
    ) {
    }

    /**
     * Supprime une clef
     *
     * @param clef Identifiant
     */
    deleteClef(clef: string): Observable<Result> {
        return this.http.delete<Result>(`${environment.baseUrl}/controller/InterfaceReferentiel/ClefExport/deleteClef/${clef}`).pipe(first());
    }

    /**
     * Création d'une clef
     *
     * @param exportClefs Tableau avec l'ancienne et la nouvelle clef
     */
    saveClef(exportClefs: ExportClef[]): Observable<Result> {
        //Appel de la route de création
        return this.http.post<Result>(`${environment.baseUrl}/controller/InterfaceReferentiel/ClefExport/saveClef`,exportClefs).pipe(first());
    }
}
